import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useState } from "react";

type UseTaskMetadataExportResult = [
    () => Promise<void>,
    boolean
];


type UseTaskMetadataExportSignature = 
(
    taskId?: number,
    workitemId?: number,
    exportSuffix?: string,
) => UseTaskMetadataExportResult;

const useTaskMetadataExport : UseTaskMetadataExportSignature = (taskId, workitemId, exportSuffix ) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);
    const [working, setWorking] = useState(false);

    const fileName = `${(workitemId ? workitemId.toString() : 'metadataExport')}${exportSuffix ? ` ${exportSuffix}` : ''}.csv`;

    const handleExport = async () => {
        setWorking(true);
        const resp = await fetcher(`/api/v3/tasks/${taskId}/metadata/export`);

        const blob = new Blob([await resp.blob()], { type: "text/csv" });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        setWorking(false);
    };

    return [
        handleExport,
        working
    ];
}

export default useTaskMetadataExport;